import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SetupComponent from '../../components/signup/setup';
import analytics from '../../lib/analytics';
import { getInvalidFields } from '../../lib/shared-signup';
import { showThirdBullet } from '../../components/helpers/sign-up';
import { captureAbandonedSignup } from '../../lib/helpers';
import { setAbandonedSignupTracker } from '../../store/data';
const Setup = () => {
    const dispatch = useDispatch();
    const { system: { activeFlow }, sharedSignup, avataxSignup: { partnerSignup, selectedConnector }, data: { marketingData, abandonedSignupTracker: boundAbandonedSignup }, abTesting: { group }, } = useSelector((state) => state);
    const { signupForm } = sharedSignup;
    const isDirectToBuy = activeFlow === 'avatax-direct-buy';
    const containsInvalidOrMissingFields = Boolean(getInvalidFields(sharedSignup).length);
    const continueLink = partnerSignup ? '/buy/buy' : '/buy/connector';
    const continueLinkText = partnerSignup ? 'Continue' : 'Next';
    const showThirdBulletValue = showThirdBullet(group, partnerSignup);
    useEffect(() => {
        if (selectedConnector) {
            analytics.page('SIGNUP_COMPANY_INFO', { connector: selectedConnector.name });
        }
        else {
            analytics.page('SIGNUP_COMPANY_INFO');
        }
        window.removeEventListener('unload', boundAbandonedSignup || (() => undefined));
        const abandonedSignupHandler = boundAbandonedSignup
            || captureAbandonedSignup.bind(null, {
                activeFlow,
                firstName: signupForm.firstName,
                lastName: signupForm.lastName,
                email: signupForm.email,
                phone: signupForm.phone,
                company: {
                    address: signupForm.street1,
                    company_name: signupForm.companyName,
                    city: signupForm.city,
                    country: signupForm.country,
                    postal_code: signupForm.postalCode,
                    state: signupForm.state,
                },
                marketingData,
            });
        window.addEventListener('unload', abandonedSignupHandler);
        dispatch(setAbandonedSignupTracker(abandonedSignupHandler));
        return () => {
            window.removeEventListener('unload', abandonedSignupHandler);
        };
    }, [
        activeFlow,
        selectedConnector,
        marketingData,
        signupForm,
        boundAbandonedSignup,
    ]);
    const props = {
        partnerSignup,
        isDirectToBuy,
        containsInvalidOrMissingFields,
        continueLink,
        continueLinkText,
        showThirdBullet: showThirdBulletValue,
    };
    return React.createElement(SetupComponent, Object.assign({}, props));
};
export default Setup;
